var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeciality19(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#707070;}.b{clip-path:url(#a);}.c{fill:#208ce1;stroke:#fff;stroke-width:0.2px;}.d{fill:#e2e8f3;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 50,
    height: 50,
    transform: "translate(-1443 -6983)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(1443 6983)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.728)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M69.291,37.677l-8.055-8.054V24.756a4.038,4.038,0,0,0-.568-2.066L55,13.15a2.441,2.441,0,0,1-.343-1.247V9.3a2.872,2.872,0,0,0,2.1-2.757V2.877A2.88,2.88,0,0,0,53.876,0H39.04a2.881,2.881,0,0,0-2.877,2.877V6.541a2.873,2.873,0,0,0,2.1,2.757V11.9a2.4,2.4,0,0,1-.044.433l-.008.038a2.429,2.429,0,0,1-.291.776l-5.671,9.539a4.044,4.044,0,0,0-.568,2.066V44.986a3.034,3.034,0,0,0,3.03,3.03h23.5a3.03,3.03,0,0,0,2.628-1.528,6.108,6.108,0,0,0,8.457-8.811ZM37.767,6.541V2.877A1.275,1.275,0,0,1,39.04,1.6H53.876A1.275,1.275,0,0,1,55.15,2.877V6.54a1.274,1.274,0,0,1-1.273,1.273H39.04A1.274,1.274,0,0,1,37.767,6.541ZM39.3,13.97a5.207,5.207,0,0,0,.568-2.771V9.418H53.05V11.9a4.038,4.038,0,0,0,.568,2.066l5.672,9.539a2.425,2.425,0,0,1,.2.445H33.425a2.461,2.461,0,0,1,.2-.445ZM58.206,46.413H34.711a1.428,1.428,0,0,1-1.427-1.427c-.028-15.72,0-19.429,0-19.429H59.633v2.628a6.111,6.111,0,0,0-7.723,9.4L59.6,45.276A1.43,1.43,0,0,1,58.206,46.413Zm9.951-1.226a4.515,4.515,0,0,1-6.376,0l-3.8-3.8,3.9-3.9a.8.8,0,1,0-1.134-1.134l-3.9,3.9-3.8-3.8a4.508,4.508,0,0,1,6.375-6.375l8.738,8.738a4.507,4.507,0,0,1,0,6.375Z",
    transform: "translate(-1466.952 -6981.889)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M-1433.963-6948.368s-1.9,15.1,3.721,15.046,12.943,0,12.943,0-4.82-3.5-10.08-3.479S-1433.963-6948.368-1433.963-6948.368Z",
    transform: "translate(1.728 -3.192)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeciality19);
export default __webpack_public_path__ + "static/media/speciality19.e65dfccf3fd6cff05234fdaca3fff4ba.svg";
export { ForwardRef as ReactComponent };